













































import { computed, defineComponent, ref } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useFormat } from 'vivat';

import useAuth from '@/useAuth';

import getHubs from '@/gql/company/getHubs.gql';
import getHubOverallDailyReport from '@/gql/dashboard/getHubOverallDailyReport.gql';

const HubTotal = defineComponent({
  setup() {
    const { me } = useAuth();
    const NOW = useFormat.date().computerShortDate();
    function displayDate(date: string) {
      return useFormat.date(date).displayFullThaiDate();
    }

    const { result: getHubsResult } = useQuery(getHubs, {
      first: 100,
      page: 1,
    }, () => ({ fetchPolicy: 'cache-and-network' }));
    const hubs = useResult(getHubsResult, {
      data: [], paginatorInfo: { currentPage: 1 },
    }, (data: any) => data.me.company.hubs);

    const { result: getHubOverallDailyReportResult } = useQuery(getHubOverallDailyReport, {
      date: NOW,
    }, () => ({ fetchPolicy: 'cache-and-network' }));
    const hubOverallDailyReport = useResult(getHubOverallDailyReportResult, {
      totalWeight: 0,
      deliveryTime: [],
      unfinishDelivery: [],
      unfinishWeight: [],
    }, (data: any) => data.overallDailyReportHub);

    const computedOverallDailyReport = computed(() => {
      const tempDeliveryTime = hubOverallDailyReport.value.deliveryTime;
      const tempUnfinishDelivery = hubOverallDailyReport.value.unfinishDelivery;
      const tempUnfinishWeight = hubOverallDailyReport.value.unfinishWeight;
      const result = hubs.value.data.map((hub: any) => {
        let res = hub;
        for (let i = 0; i < tempDeliveryTime.length; i += 1) {
          if (res.id === tempDeliveryTime[i].hubId) {
            res = {
              ...res,
              totalWeight: 0,
              deliveryTime: tempDeliveryTime[i].value || 0,
              unfinishDelivery: tempUnfinishDelivery[i].value || 0,
              unfinishWeight: tempUnfinishWeight[i].value || 0,
            };
            break;
          }
        }
        return res;
      });

      return result;
    });

    return {
      NOW,
      me,

      hubOverallDailyReport,
      computedOverallDailyReport,
      // filterDateRange,
      displayDate,

      hubs,
    };
  },
});

export default HubTotal;
